import { DialogTitle } from '@mui/material';

import { GDMDialogTitleComponent } from './GDMDialogTitle.type';

/* TODO: Implement component using GDM default design */
const GDMDialogTitle: GDMDialogTitleComponent = props => <DialogTitle {...props} />;

export default GDMDialogTitle;
